module.exports = __webpack_public_path__ + "c5e3481ad45abf5c4ddeeb65e3881dfa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-6.png
// module id = 1548
// module chunks = 0